export default "__VITE_ASSET__Wqf29vVQ__"